import { ArgsType, Field } from '@nestjs/graphql'
import { BaseCreateDto } from '../base/baseCreate.dto'

@ArgsType()
export class AddVirtualAssistantDto extends BaseCreateDto<AddVirtualAssistantDto> {
  @Field()
  emailAddress!: string
}
